// extracted by mini-css-extract-plugin
export default {"container":"TransactionAmount_container__taniK","lineThrough":"TransactionAmount_lineThrough__kJlJa"};